module.exports = __webpack_public_path__ + "img/ic_logo_week-of-mediawisdom@3x.3852a730.png";